import { render, staticRenderFns } from "./SimpleCheckItemRenderer.vue?vue&type=template&id=357dde2a&scoped=true&"
import script from "./SimpleCheckItemRenderer.vue?vue&type=script&lang=js&"
export * from "./SimpleCheckItemRenderer.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCheckItemRenderer.vue?vue&type=style&index=0&id=357dde2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357dde2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357dde2a')) {
      api.createRecord('357dde2a', component.options)
    } else {
      api.reload('357dde2a', component.options)
    }
    module.hot.accept("./SimpleCheckItemRenderer.vue?vue&type=template&id=357dde2a&scoped=true&", function () {
      api.rerender('357dde2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/CheckingManager/SimpleCheckItemRenderer.vue"
export default component.exports